<template>
    <div class="home-footer">
        <div class="top-footer">
            <div class="top-footer-inner br-logo-img">
                <div class="group-logo">
                    <div class="logo-image logo-laptop">
                        <img :src="require('@/assets/home/logo_slim.png')" alt="Logo Academy">
                    </div>
                    <div class="infor-contact">
                        <ul class="ul-infor">
                            <div class="name-company">
                                <div class="logo-image logo-mobile">
                                    <img :src="require('@/assets/home/logo_slim.png')" alt="Logo Academy">
                                </div>
                                <p>TECHBIM VIETNAM</p>
                            </div>
                            <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                        class="fa-solid fa-map-location"></i> </span> <span class="a-infor">30 Hòa Minh
                                    22, P. Hòa Khánh, TP Đà Nẵng</span> </li>
                            <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                        class="fa-solid fa-mobile-screen-button"></i></span> <a target="_blank"
                                    class="a-infor" href="tel:+097 515 9695">097 515 9695</a></li>
                            <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                        class="fa-solid fa-envelope"></i></span> <a class="a-infor" target="_blank"
                                    href="mailto:lehongphuongweb@gmail.com"> lehongphuongweb@gmail.com</a></li>
                        </ul>
                    </div>
                    <!-- <div class="logo-image logo-right">
                        <img :src="require('@/assets/home/logo_slim.png')" alt="Logo Academy">
                    </div> -->
                </div>
            </div>
            <div class="top-footer-inner">
                <p class="title-contact">LIÊN KẾT NHANH</p>
                <ul class="ul-infor">
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                class="fa-brands fa-tiktok"></i></span> <a class="a-infor" target="_blank"
                            href="https://www.tiktok.com/@techbim.vn?_t=ZS-8xs3WNnm7us&_r=1">https://www.tiktok.com/@techbim.vn</a>
                    </li>
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                class="fa-brands fa-youtube"></i></span> <a class="a-infor" target="_blank"
                            href="https://www.youtube.com/@Techbim_vn"> https://www.youtube.com/@Techbim_vn</a></li>
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <span><i
                                class="fa-solid fa-house"></i></span> <a class="a-infor" target="_blank"
                            href="https://techbim.vn">https://techbim.vn</a></li>
                </ul>
            </div>
            <div class="top-footer-inner">
                <p class="title-contact">HỖ TRỢ HỌC VIÊN</p>
                <ul class="ul-infor">
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <a class="a-infor"
                            href="/">Giới thiệu</a></li>
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <a class="a-infor"
                            href="/cong-dong">Diễn đàn</a></li>
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <a class="a-infor"
                            href="/khoa-hoc">Đào tạo</a></li>
                </ul>
            </div>
            <!-- <div class="top-footer-inner">
                <p class="title-contact">CHÍNH SÁCH ĐIỀU KHOẢN</p>
                <ul class="ul-infor">
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <a class="a-infor" href="#">Điều khoản dịch vụ</a></li>
                    <li><span class="square-icon"><i class="fa-solid fa-square"></i></span> <a class="a-infor" href="#">Chính sách bảo mật</a></li>
                </ul>
            </div> -->
        </div>
        <div class="bottom-footer">
            <!-- <div class="social text-center">
                <a target="_blank" href="https://www.facebook.com/profile.php?id=100075925281383" class="mr-2"><span><i
                            class="fa-brands fa-facebook-f"></i></span></a> <a
                    href="https://www.youtube.com/@Techbim_vn" target="_blank"><span><i
                            class="fa-brands fa-youtube"></i></span></a>
            </div> -->
            <div class="copyright">
                <p class="text-center">© Copyright 2025 Techbim, all right reserved</p>
                <p class="text-center">Made with 
                    <!-- <span class="text-danger"><i class="fa-solid fa-heart"></i></span>  -->
                    by Techbim</p>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "HomeFooter",
    components: {

    },
}
</script>
<style src="./home-footer-responsive.css"></style>
<style scoped>
.br-logo-img {
    /* background-image: url('~@/assets/footer-map-world.png'); */
}

.home-footer {
    /* margin-top: 10px; */
    background-color: #232F3E;
    color: white;
    padding: 60px 10%;
    padding-bottom: 10px;
    position: relative;
}

.top-footer {
    display: flex;
    justify-content: space-between;
}

.top-footer-inner {
    /* width: 30%; */
    width: fit-content;
}

.top-footer-inner.br-logo-img {
    /* width: 40%; */
}

.title-contact {
    font-size: 20px;
}

.ul-infor li {
    background-color: #232F3E;
    padding: 10px 0px;
    /* padding-left: 15px; */
    display: flex;
    align-items: center;
    font-size: 14px;
    position: relative;
}

a:hover {
    color: white;
}

/* .ul-infor li:before {
  content : "";
  position: absolute;
  left    : 0;
  bottom  : 0;
  height  : 1px;
  width   : 20%;  
  border-bottom:1px solid rgb(89, 89, 89);
} */
.square-icon {
    font-size: 6px;
    margin-right: 20px;
    color: #A8D0E6;
}

.a-infor {
    margin-left: 6px;
}

/* bottom-footer */
.bottom-footer {
    margin-top: 20px;
}

.social {
    font-size: 30px;
    display: block;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}
</style>